export const getOpsCenters = ({ state }) => state.signinForm.opsCenters;
export const getDisableLoginBtn = ({ state }) => state.signinForm.disableLoginBtn;
